import { useEffect, useRef } from "react"
import { useRouter } from "next/router"

import { useQueryParams } from "@/hooks/useQueryParams"

import { CREATE_TEMPLATE_QUERY_PARAM } from "../constants"

/**
 * Opens the existing Save as Template dialog when the templates page sends a
 * user to the launcher explicitly to create a template. The URL marker is
 * replaced after consumption so refreshing the launcher does not reopen it.
 */
export function useCreateTemplateIntent(onCreateTemplate: () => void): void {
  const router = useRouter()
  const queryParams = useQueryParams()
  const hasHandledIntent = useRef(false)

  const createTemplateIntent = router.query[CREATE_TEMPLATE_QUERY_PARAM]
  const shouldOpenTemplateDialog =
    router.isReady &&
    (createTemplateIntent === "true" || createTemplateIntent?.includes("true"))

  useEffect(() => {
    if (!shouldOpenTemplateDialog || hasHandledIntent.current) {
      return
    }

    hasHandledIntent.current = true
    onCreateTemplate()
    queryParams.setMultiple(
      { [CREATE_TEMPLATE_QUERY_PARAM]: null },
      { history: "replace", shallow: true },
    )
  }, [onCreateTemplate, queryParams, shouldOpenTemplateDialog])
}
